/**
 * Unit conversions for the rocket-nozzle UI (imperial display ↔ SI internals).
 * Constants are exact where the legal definitions are exact.
 */

// length / area
export const FT_PER_M = 0.3048;
export const FT2_PER_M2 = 0.09290304; // (0.3048)^2 exactly
export const ftToM = (v: number) => v * FT_PER_M;
export const mToFt = (v: number) => v / FT_PER_M;
export const ft2ToM2 = (v: number) => v * FT2_PER_M2;
export const m2ToFt2 = (v: number) => v / FT2_PER_M2;

// pressure
export const PA_PER_PSI = 6894.757293168361;
export const psiToPa = (v: number) => v * PA_PER_PSI;
export const paToPsi = (v: number) => v / PA_PER_PSI;

// velocity
export const fpsToMs = (v: number) => v * FT_PER_M;
export const msToFps = (v: number) => v / FT_PER_M;

// mass & force
export const KG_PER_LB = 0.45359237;
export const N_PER_LBF = 4.4482216152605;
export const lbToKg = (v: number) => v * KG_PER_LB;
export const kgToLb = (v: number) => v / KG_PER_LB;
export const lbfToN = (v: number) => v * N_PER_LBF;
export const nToLbf = (v: number) => v / N_PER_LBF;

// temperature
export const fahrenheitToKelvin = (f: number) => (f + 459.67) * (5 / 9);
export const kelvinToFahrenheit = (k: number) => k * (9 / 5) - 459.67;
